module.exports = __webpack_public_path__ + "static/media/melanie&danielw-64_websize.3eb3d863.jpg";